/* eslint-disable react/prop-types */
import React from 'react';
import request from '@api';
import { useEffectOnce } from '@hooks';

import bankImg from '@assets/bank_icon.svg';
import { ICON_MAP } from '@constants';

const Context = React.createContext();

export function ConnectionProvider({ children }) {
  const [isLoading, setIsLoading] = React.useState(true);
  const [payment, setPayment] = React.useState({});
  const [store, setStore] = React.useState({});
  const [appInstalled, setAppInstalled] = React.useState(null);
  const [merchantId, setMerchantId] = React.useState(null);

  const queryConnection = async () => {
    const connection = await request('user-connection-info').catch((err) => {
      console.log(err);
      setIsLoading(false);
    });
    setIsLoading(false);
    const {
      code, data = {},
    } = connection || {};
    const {
      adminDomain, platform, payment: paymentData, raAppStatus, merchantId: mID,
    } = (data.merchantVOS || [])[0] || {};
    const { bankName, bankNumber, connected: hasPayment } = paymentData || {};
    const installed = raAppStatus === 'valid';
    setAppInstalled(installed);
    setMerchantId(mID);

    setStore({
      connected: code === 0 && installed,
      title: 'CONNECTED STORE',
      emptyText: 'No account connected',
      buttonText: 'Connect store',
      name: platform,
      info: adminDomain,
      icon: ICON_MAP[platform],
    });
    setPayment({
      connected: code === 0 && (hasPayment || false),
      title: 'payment account',
      icon: bankImg,
      name: bankName,
      info: bankNumber,
      emptyText: 'No payment method added',
      buttonText: 'Add payment method',
    });
  };

  useEffectOnce(queryConnection, []);

  // eslint-disable-next-line react/jsx-no-constructed-context-values
  const value = {
    isLoading, payment, store, appInstalled, merchantId, queryConnection,
  };
  return <Context.Provider value={value}>{children}</Context.Provider>;
}

export default function useConnectionContext() {
  return React.useContext(Context);
}
